import { myShortlistApi } from '../../../api/shortlist/shortlist.api.connected';
import { myErrorService } from '../../front/ErrorService/ErrorService.connected';
import { myMessageService } from '../../internal/MessageService/MessageService.connected';
import { createShortlistMutationService } from './ShortlistMutationService.impl';

export const myShortlistMutationService = createShortlistMutationService({
  api: myShortlistApi,
  services: {
    errorService: myErrorService,
    messageService: myMessageService
  }
});

